<template>
    <div>
        <EmergencyContactPrimary />
        <EmergencyContactAdditional class="mt-2" />
        <PatientRepresentativeCordination class="mt-2" />
        <ChapsSurvey class="mt-2" />
        <ContactsComments class="mt-2" />
    </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

import EmergencyContactPrimary from "./EmergencyContactPrimary/EmergencyContactPrimary.vue";
import EmergencyContactAdditional from "./EmergencyContactAdditional/EmergencyContactAdditional.vue";
import PatientRepresentativeCordination from "./PatientRepresentativeCordination/PatientRepresentativeCordination.vue";
import ChapsSurvey from "./ChapsSurvey/ChapsSurvey.vue";
import ContactsComments from "./ContactsComments/ContactsComments.vue";

export default defineComponent({
    components: {
        EmergencyContactPrimary,
        EmergencyContactAdditional,
        PatientRepresentativeCordination,
        ChapsSurvey,
        ContactsComments
    }
});
</script>
